module.exports = __webpack_public_path__ + "static/img/4.3c3bf70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news28/4.png
// module id = /C0l
// module chunks = 1